import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useProyecto } from "../../../data/ProyectoContext";
import { iProyectoABP } from "../../../interfaces/Proyecto/iProyecto";

const HabilidadesSocioemocionales = () => {
  const { proyecto, setProyecto } = useProyecto();

  const handleHabilidadesSocioemocionales = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const habilidadSocioemocional = event.target.value;
    setProyecto((prevData) => ({
      ...prevData,
      habilidad_socioemocional: habilidadSocioemocional,
    }));
  };

  return (
    <Grid item xs={12}>
      <Typography
        sx={{
          color: "#336B87",
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
        }}
      >
        Habilidades socioemocionales (SEL)
      </Typography>
      <FormLabel
        component="p"
        sx={{
          fontFamily: "montserrat",
          m: 0,
          pb: 2,
          fontSize: "0.85rem",
        }}
      >
        Selecciona las habilidades SEL que quieras desarrollar en tus
        estudiantes a través de tu tarea o actividad.
      </FormLabel>
      <Grid sx={{ display: "flex", flexDirection: "column" }}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="niveles de desempeño"
            name="tipo_evaluacion"
            value={(proyecto as iProyectoABP).habilidad_socioemocional}
            onChange={handleHabilidadesSocioemocionales}
          >
            <FormControlLabel
              value="autoconcienciaoconcienciadesimismo"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Autoconciencia o conciencia de sí mismo
                </Typography>
              }
            />
            <FormControlLabel
              value="autorregulacionautogestion"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Autorregulación o Autogestión
                </Typography>
              }
            />
            <FormControlLabel
              value="concienciasocialoconcienciadelosotros"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Consciencia Social o Consciencia de los Otros
                </Typography>
              }
            />
            <FormControlLabel
              value="habilidadespararelacionarseohabilidadesinterpersonales"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Habilidades para Relacionarse o Habilidades Interpersonales
                </Typography>
              }
            />
            <FormControlLabel
              value="tomaresponsablededecisiones"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Toma Responsable de Decisiones
                </Typography>
              }
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default HabilidadesSocioemocionales;
